import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../services/login.service';

@Component({
    selector: 'register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css'],
    providers: [LoginService]
})
export class RegisterComponent implements OnInit {

    public error:boolean;
    public errorMsg:string;

    public arrMontes:Array<any>;

    public nombre:string;
    public direccion:string;
    public cp:string;
    public correo:string;
    public password:string;
    public repeatpassword:string;
    public telf:string;
    public dni:string;

    public infoUser:any;

    public arrayMontesOutput:Array<any>;

    @Output() showRegister = new EventEmitter();

    public loaderRegister:boolean;

    constructor(private _loginService: LoginService,private _router: Router) {
        this.arrMontes=[];
        this.error=false;
        this.loaderRegister=false;
        this.arrayMontesOutput=[];
    }

    ngOnInit(): void { }

    public goLogin():void{
        this.showRegister.emit(false);
    }

    public getMontesOutput(eventoData:any):void{
        this.arrayMontesOutput = eventoData;
    }

    public sendRegister():void{
        this.loaderRegister=true;
        if(this.checkInputs()){
            if(this.checkPasswords()){
                let objInfo = {
                    "name": this.nombre,
                    "email": this.correo,
                    "password": this.password,
                    "password_repeat": this.repeatpassword,
                    "address": this.direccion,
                    "cp":this.cp,
                    "phone": this.telf,
                    "dni": this.dni,
                    "mounts": this.arrayMontesOutput
                };
                console.log(JSON.stringify(objInfo));
                this._loginService.doRegister(objInfo).subscribe(
                    response => {
                        if(response.code == 0){
                            this.error=true;
                            this.errorMsg = response.message;
                            this.loaderRegister=false;
                            setTimeout(()=>{
                                this.error = false;
                            },3000);
                          }else if(response.code == 1){
                            this.error=true;
                            this.errorMsg = 'Login incorrecto';
                            this.loaderRegister=false;
                            setTimeout(()=>{
                                this.error = false;
                            },3000);
                          }else if(response.code == 3){
                            this.error=true;
                            this.errorMsg = response.message;
                            this.loaderRegister=false;
                            setTimeout(()=>{
                                this.error = false;
                            },3000);
                          }else if(response.code == 4){
                            this.error=true;
                            this.errorMsg = response.message;
                            this.loaderRegister=false;
                            setTimeout(()=>{
                                this.error = false;
                            },3000);
                          }else{
                            this.infoUser=response.client;
                            localStorage.setItem('infoClient',JSON.stringify(this.infoUser));
                            localStorage.setItem('bearer', response.token);
                            localStorage.setItem('objsession', JSON.stringify(response.session));
                            this.loaderRegister=false;
                            this._router.navigate(["home"]);
                          }
                    },
                    error => {
                        console.error('Error '+JSON.stringify(error));
                        this.error = true;
                        this.errorMsg = error.error.message_dev;
                        this.loaderRegister=false;
                        setTimeout(()=>{
                            this.error = false;
                        },3000);
                    }
                );
            }else{
                this.error = true;
                this.errorMsg = 'Las contraseñas deben coincidir.';
                this.loaderRegister=false;
                setTimeout(()=>{
                    this.error = false;
                },3000);
            }
        }else{
            this.error = true;
            this.errorMsg = 'Debe rellenar todos los campos';
            this.loaderRegister=false;
            setTimeout(()=>{
                this.error = false;
            },3000);
        }
    }

    public checkInputs():boolean{
        if(this.nombre !== '' && this.direccion !== '' && this.cp !== '' && this.correo !== '' && this.password !== '' && this.repeatpassword !== '' && this.telf !== '' && this.dni !== ''){
            return true;
        }else{
            return false;
        }
    }

    public checkPasswords():boolean{
        if(this.password == this.repeatpassword){
            return true;
        }else{
            return false;
        }
    }

}
